/* eslint no-constant-condition: 0 */
import { take, put, call, fork, select } from "redux-saga/effects"
import restRequest from "src/engine/modules/rest/api/request"
import { REQUEST, UNLOCK_REQUESTS } from "../actions/types"
import { requestSuccess, requestError } from "../actions/creators"
import { requestsLocked as selectRequestsLocked } from "../selectors"

function* request(action) {
  const requestsLocked = yield select(selectRequestsLocked)

  if (requestsLocked) {
    /* If requests locked we should freeze current request,
     * and wait for unlock event */
    yield take(UNLOCK_REQUESTS)
  }

  const { url, query, options } = action.config

  try {
    const response = yield call(restRequest, url, query, options)

    yield put(requestSuccess(action, response))
  } catch (error) {
    yield put(requestError(action, error))
  }
}

export default function* requestSaga() {
  while (true) {
    const action = yield take(REQUEST)
    yield fork(request, action)
  }
}
